module.exports = __webpack_public_path__ + "static/media/home-options-2.afcc9d86.webp";